const STORAGE_KEY = "makebeetrip_bus_booking";

export function saveBusBooking(booking) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(booking));
}

export function readBusBooking() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
